import { render } from "./OrgSignUpView.vue?vue&type=template&id=7cedd024"
import script from "./OrgSignUpView.vue?vue&type=script&lang=js"
export * from "./OrgSignUpView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__